import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/analytics/overview.md?raw';

const AnalyticsOverview: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default AnalyticsOverview;
